// @flow

import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation UpdateItemChildMutation($input: UpdateItemChildInput!) {
    updateItemChild(input: $input) {
      itemEdge {
        node {
          id
          itemNumber
          name
          upc
          quantityUOM {
            id
            name
            type
            symbol
          }
          childItems(first: null)
            @connection(key: "Item_childItems", filters: []) {
            edges {
              usageQty
              bomType
              referenceDesignator
              findNumber
              notes
              isPhantom
              scrapFactor
              leadTimeOffsetDays
              isBackflush
              workflowStateId
              fixedQuantity
              isOptional
              selectionGroup
              isDefaultSelection
              optionLabel
              minQuantity
              maxQuantity
              priceAdjustment
              isCustomerVisible
              salesDisplayName
              componentPrice
              discountPercent
              sortOrder
              isShippedSeparately
              isReplaceable
              serviceIntervalDays
              meanTimeBetweenFailure
              repairMethod
              serviceNotes
              isCriticalSpare
              node {
                id
                name
              }
            }
          }
          formFieldValues
        }
      }
    }
  }
`;

export default {
  commit: createRelayMutation.bind(null, mutation),
};
